export const ACTION_TARGET = 'REDUCER/ACTION_TARGET';




// WEBPACK FOOTER //
// ./src/actions/types/types.js